import { Module, ActionContext } from 'vuex'
import VueRouter from 'vue-router'
import util from '@/lib/util'
import ajax from '@/lib/ajax'

interface PermissionState {
	currentUserPermissionKeys: Array<string>
}
class PermissionModule implements Module<PermissionState, any> {
	namespaced: boolean = true

	state = {
		currentUserPermissionKeys: []
	}
	mutations = {
		clearPermisssions(state: PermissionState, payload: string) {
			state.currentUserPermissionKeys = []
		}
	}
	actions = {
		async getCurrentUserPermissionKeys(context: ActionContext<PermissionState, any>, payload: any) {
			if (context.state.currentUserPermissionKeys.length > 0)
				return context.state.currentUserPermissionKeys
			return await ajax.get<Array<string>>('/api/app/permission/currentUserPermissionKeys').then(rep => {
				context.state.currentUserPermissionKeys = rep.data
				window.sessionStorage.setItem('permission', JSON.stringify(rep.data))
				// console.log('rep.data: ', rep.data.find(t=>t === 'order-manager'))
				return rep.data
			})
		},
		clearUserPermissionKeys(context: ActionContext<PermissionState, any>, payload: any) {
			context.state.currentUserPermissionKeys = []
		},
		hasPermission(context: ActionContext<PermissionState, any>, payload: string) {
			let permissions: Array<string> = context.state.currentUserPermissionKeys
			return permissions.findIndex(t => t.toLowerCase() === payload.toLowerCase()) > -1
		}
	}
}
const permissionModule = new PermissionModule()
export default permissionModule
